<template>
    <div class="DshDefaultSearch bri-scrollbar6">
        <Row :gutter="10">
            <template v-for="conditionItem in valueConditions">
                <Col :key="conditionItem._id"
                    :span="conditionItem.formItem._span"
                >
                    <dsh-formItem
                        class="DshDefaultSearch-item"
                        labelWidth="100"
                        height="46"
                        :key="conditionItem._id"
                        :canEdit="canEdit"
                        :formData="conditionItem"
                        :formItem="{ ...conditionItem.formItem, ...defaultFormItem }"
                        :rowStyle="rowStyle"
                        @change="change(conditionItem, arguments)"
                    >
                        <span slot="label" class="DshDefaultSearch-item-name">
                            {{ conditionItem.formItem._name }}:
                        </span>
                    </dsh-formItem>
                </Col>
                <!-- 换行 -->
                <div v-if="conditionItem.formItem._wrap" :key="conditionItem._id" style="width:100%"></div>
            </template>
        </Row>
    </div>
</template>

<script>
    import searchMixin from "./searchMixin.js";

    export default {
        name: "DshDefaultSearch",
        mixins: [searchMixin],
        props: {
            canEdit: {
                type: Boolean,
                default: true
            },

            value: {
                type: Object,
                default () {
                    return {
                        conditions: []
                    };
                }
            },
            formList: {
                type: Array,
                default () {
                    return [];
                }
            },
            initSearchFields: {
                type: Array,
                default () {
                    return [];
                }
            },
            initData: {
                type: Object,
                default () {
                    return {};
                }
            },
            fieldTypeMap: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {
                defaultFormItem: {
                    _line: true
                },
                rowStyle: {
                    width: "calc(100% - 12px)"
                }
            };
        },
        computed: {
            searchFormList () {
                return this.formList;
            },
            valueConditions () {
                return this.value.conditions.map(item => {
                    item.formItem.canEdit = true; // 所有筛选项都能编辑
                    if (["select", "checkbox"].includes(item.formItem._type)) {
                        item.formItem._useColor = false;
                    }
                    return item;
                });
            }
        },
        created () {
            this.init();
        },
        methods: {
            // 初始化
            init () {
                if (this.initSearchFields.length !== 0) {
                    this.value.conditions = this.initSearchFields.map(fieldKey => {
                        let formItem = this.formList.find(formItem => formItem._key === fieldKey);
                        if (formItem) {
                            return this.createCondition(formItem);
                        }

                    }).filter(conditionItem => !!conditionItem);
                }
                if (this.initData.conditions && this.initData.conditions.length) {
                    Object.assign(this.value, {conditions: this.initData.conditions});
                }
                this.value.conditions = this.value.conditions.map(conditionItem => {
                    return {
                        ...conditionItem,
                        formItem: this.getFormItem(conditionItem.key, null, "header")
                    };
                });
            },
            // 生成筛选条件的值
            createCondition (formItem) {
                return {
                    key: formItem._key,
                    fieldValue: ["text", "textarea", "idcard", "email", "phone"].includes(formItem._type) ? "" : [],
                    formItem: this.getFormItem(null, formItem, "header")
                };
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshDefaultSearch {
        max-height: 40%;
        overflow: auto;
        &-item {
            padding: 0 !important;
            padding-bottom: 6px !important;
            padding-top: 6px !important;
            margin-top: 0px!important;
            margin-bottom: 0px!important;
            &-name {
                color: #909090;
            }
        }
    }
</style>
<style lang="less">
    .DshDefaultSearch {
        .DshFormItem-line .DshFormItem-label {
            text-align: right;
            margin-right: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/form/DshDefaultSearch.vue